import request from '@/utils/request'

let Vehicle_durationApi = {

  /*车辆年限列表*/
  list(data) {
    return request._post('/shop/plus.vehicle_duration.Index/index', data);
},
/*添加车辆年限*/
add(data) {
    return request._post('/shop/plus.vehicle_duration.Index/add', data);
},
/*修改车辆年限*/
edit(data) {
    return request._post('/shop/plus.vehicle_duration.Index/edit', data);
},
/*删除车辆年限*/
del(data) {
    return request._post('/shop/plus.vehicle_duration.Index/del', data);
},
/*车辆年限详情*/
detail(data) {
  return request._post('/shop/plus.vehicle_duration.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vehicle_duration.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vehicle_duration.Setting/getSetting', data, errorback);
    },
}
export default Vehicle_durationApi;



// WEBPACK FOOTER //
// ./src/api/vehicle_duration.js